import { render, staticRenderFns } from "./annex-info.vue?vue&type=template&id=035178bc&scoped=true"
import script from "./annex-info.vue?vue&type=script&lang=ts"
export * from "./annex-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035178bc",
  null
  
)

export default component.exports